import { get, post } from '../../tools/http';

const client = {
    async getTasks(groupId) {
        return get('profile', `tasks/${groupId}`);
    },

    async createTask(data) {
        return post('profile', 'task/create', data, true);
    },

    async updateTask(data) {
        return post('profile', 'task/update', data, true);
    },

    async completeTask(data) {
        return post('profile', 'task/completion', data, true);
    },

    async removeTask(id) {
        return get('profile', `task/remove/${id}`);
    },
};

export default {
    namespaced: true,
    state: {
        tasks: [],
    },
    mutations: {
        setTasks: (state, items) => state.tasks = items.map(v => {
            v.deadline = new Date(v.deadline);
            return v;
        }),
        setLocalCompleted: (state, { taskId, isCompleted}) => {
            let i = state.tasks.findIndex(v => v.id === taskId);
            if (i > -1) {
                state.tasks[i].completed = isCompleted;
            }
        },
    },
    actions: {
        async loadTasks(ctx) {
            let groupId = ctx.rootState.mentoring.groupId;
            if (groupId) {
                let tasks = (await client.getTasks(groupId)).tasks;
                ctx.commit('setTasks', tasks);
            }
        },
        async setCompletion(ctx, { taskId, isCompleted }) {
            await client.completeTask({
                "task_id": taskId,
                "completed" : isCompleted,
            });
            ctx.commit('setLocalCompleted', { taskId, isCompleted });
            ctx.dispatch('loadTasks');
        },
        async createTask(ctx, item) {
            await client.createTask({
                ...item,
                group_id: ctx.rootState.mentoring.groupId,
            });
            ctx.dispatch('loadTasks');
        },
        async updateTask(ctx, item) {
            await client.updateTask({
                ...item,
                group_id: ctx.rootState.mentoring.groupId,
            });
            ctx.dispatch('loadTasks');
        },
        async removeTask(ctx, taskId) {
            await client.removeTask(taskId);
            ctx.dispatch('loadTasks');
        },
    },
    getters: {
        incomingTasks: state => state.tasks
            .filter(v => !v.completed && v.deadline > new Date())
            .sort((a, b) => a.deadline.getTime() - b.deadline.getTime()),
        missedTasks: state => state.tasks
            .filter(v => !v.completed && v.deadline < new Date())
            .sort((a, b) => b.deadline.getTime() - a.deadline.getTime()),
        completedTasks: state => state.tasks
            .filter(v => v.completed)
            .sort((a, b) => b.deadline.getTime() - a.deadline.getTime()),
        meetingTasks: state => (meetingId) => state.tasks
            .filter(v => v.meetingId === meetingId)
            .sort((a, b) => b.deadline.getTime() - a.deadline.getTime()),
    },
};